export default __webpack_public_path__ + "static/media/template.d9fa200d.xlsx";